import { Component, OnInit, ViewChild } from '@angular/core'
import { FeeScheduleODataService, IFacility, IFeeSchedule } from '@exchange/domain/.'
import { ActivatedRoute, Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import {
  ActionButtonsColumnRendererComponent,
  ConfirmModalComponent,
  GridWrapperComponent,
  Option
} from 'common-components'
import { BsModalService } from 'ngx-bootstrap/modal'
import { DateTimeColumnRendererComponent } from '../../shared/controls/grid-renderer/date-time-column.renderer.component'

@Component({
  selector: 'app-fee-schedule-list',
  templateUrl: './fee-schedule-list.component.html',
  standalone: false
})
export class FeeScheduleListComponent implements OnInit {
  model: IFeeSchedule = null
  states: Option[] = []

  @ViewChild('grid', { static: true }) grid: GridWrapperComponent

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private odata: FeeScheduleODataService,
    private toastr: ToastrService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.initializeGrid()
    const sm = this.route.snapshot.queryParams['successMessage']
    if (sm) {
      this.toastr.success(sm)
    }
  }

  addEntity(): void {
    this.router.navigate(['/system', 'feeschedules', 0])
  }

  editClicked(data) {
    const model = data as IFacility
    this.router.navigate(['/system', 'feeschedules', model.Id])
  }

  deleteClicked(data) {
    this.model = data as IFeeSchedule
    this.modalService
      .show(ConfirmModalComponent, {
        initialState: {
          title: `Delete Fee Schedule?`,
          message: `Are you sure you want to delete the selected Fee Schedule?`
        }
      })
      .content.onClose.subscribe(userConfirm => userConfirm && this.deleteModel())
  }

  deleteModel(): void {
    this.odata
      .delete(this.model.Id)
      .exec()
      .subscribe(response => this.grid.getData())
  }

  initializeGrid() {
    this.grid.gridOptions.context = {
      canEdit: true,
      canDelete: true,
      editHandler: this.editClicked.bind(this),
      deleteHandler: this.deleteClicked.bind(this),
      overrideTimeZone: 'US/Eastern'
    }
    this.grid.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'Actions',
        pinned: 'left',
        width: 100,
        cellRenderer: ActionButtonsColumnRendererComponent
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Active On',
        field: 'ActiveOnDateTime',
        width: 100,
        cellRenderer: GridWrapperComponent.DateWithoutTimeRenderer(),
        filter: 'agDateColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Expires On',
        field: 'ExpiresOnDateTime',
        width: 100,
        cellRenderer: GridWrapperComponent.DateWithoutTimeRenderer(),
        filter: 'agDateColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Last Modified By',
        field: 'ModifiedByFullName',
        width: 100,
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Modified On',
        field: 'ModifiedOn',
        width: 100,
        filter: 'agDateColumnFilter',
        cellRenderer: DateTimeColumnRendererComponent,
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.grid.odata = this.odata
  }
}
